export default "__VITE_ASSET__IOPGnM_w__"